import classNames from 'classnames'
import React from 'react'

import './ProductWindow.scss'

const ProductWindow = ({
  children,
  isStatic,
}: React.PropsWithChildren<{
  isStatic?: boolean
}>) => (
  <div
    className={classNames('productWindow', {
      'productWindow--static': isStatic,
    })}
  >
    {isStatic ? (
      children
    ) : (
      <div className="productWindow__scroller">{children}</div>
    )}
  </div>
)

export default ProductWindow
